<template>
  <JsonField v-model="context.value.value[props.field.key]" v-bind="props" />
</template>

<script setup lang="ts">
import { useFormKitContext } from '@formkit/vue'

import JsonField from '@/components/common/forms/editor-fields/JsonField.vue'

import type { SchemaFormKitProps } from './types'

const context = useFormKitContext()
const props = defineProps<SchemaFormKitProps>()
</script>
